import React from "react";
import { Modal } from "@mui/material";
import Button from "components/atoms/Button";

import * as Styled from "../ModalConfiguracoesStyles";

export type MessageType = "enable" | "disable";

type ServiceMessages = {
  enable: string;
  disable: string;
};

type ServiceConfig = {
  title?: string;
  messages: ServiceMessages;
  confirmButtonText?: string;
  cancelButtonText?: string;
};

const serviceConfigs: Record<string, ServiceConfig> = {
  superRecolhe: {
    messages: {
      enable:
        "Apenas revendas selecionadas pela Supergasbras podem participar do programa Super Recolhe. Caso essa revenda não esteja em conformidade com os critérios estabelecidos do programa, ela não pode ser habilitada.",
      disable:
        "Deseja desabilitar essa revenda para a iniciativa Super Recolhe?",
    },
  },
  agendamento: {
    messages: {
      enable:
        "Somente revendas autorizadas permitem o recurso de Agendamento. Ao ativar essa opção, é permitido que o usuário faça o agendamento da entrega, via Whatsapp, quando a revenda estiver fora do horário de funcionamento.",
      disable:
        "Ao desabilitar a marcação do Agendamento, não será permitido que o usuário faça agendamentos para entrega após o horário de funcionamento da revenda.\n\nDeseja desabilitar essa revenda para o serviço de Agendamento?",
    },
  },
  schedulingEnabled: {
    messages: {
      enable:
        "Somente revendas autorizadas permitem o recurso de Agendamento. Ao ativar essa opção, é permitido que o usuário faça o agendamento da entrega, via Whatsapp, quando a revenda estiver fora do horário de funcionamento.",
      disable:
        "Ao desabilitar a marcação do Agendamento, não será permitido que o usuário faça agendamentos para entrega após o horário de funcionamento da revenda.\n\nDeseja desabilitar essa revenda para o serviço de Agendamento?",
    },
  },
  onlinePaymentEnabled: {
    messages: {
      enable:
        "O Pagamento Online permite a revenda oferecer o pagamento online para seus clientes.",
      disable:
        "Deseja desabilitar essa revenda para o serviço de Pagamento Online?",
    },
  },
  gasDoPovo: {
    messages: {
      enable:
        "Somente revendas selecionadas pela Supergasbras podem participar do programa Gás do Povo. Se a revenda não atender aos critérios do programa, ela não deve ser habilitada.",
      disable:
        "Ao desabilitar a marcação de Gás do Povo serão removidas as marcações, identificações e SKU que identificam a participação da revenda no programa. Deseja desabilitar essa revenda para a iniciativa Gás do Povo?",
    },
  },
};

type ModalServiceConfigProps = {
  isOpen: boolean;
  onNo: () => void;
  onYes: () => void;
  serviceName: string;
  messageType: MessageType;
};

const ModalServiceConfig = ({
  isOpen,
  onNo,
  onYes,
  serviceName,
  messageType,
}: ModalServiceConfigProps) => {
  const config = serviceConfigs[serviceName];
  const message = config?.messages[messageType] || "";

  const title = config?.title || `Aviso`;
  const confirmButtonText = config?.confirmButtonText || "Sim, estou ciente";
  const cancelButtonText = config?.cancelButtonText || "Cancelar";

  return (
    <Modal closeAfterTransition keepMounted open={isOpen} onClose={onNo}>
      <Styled.Box>
        <Styled.ModalTitle>{title}</Styled.ModalTitle>
        <Styled.ModalBody>{message}</Styled.ModalBody>
        <Styled.ContentActions>
          <Button color="inherit" variant="outlined" onClick={onNo}>
            {cancelButtonText.toUpperCase()}
          </Button>
          <Button color="primary" variant="contained" onClick={onYes}>
            {confirmButtonText.toUpperCase()}
          </Button>
        </Styled.ContentActions>
      </Styled.Box>
    </Modal>
  );
};

export default ModalServiceConfig;
